export default __webpack_public_path__ + "static/media/FamilyNumber4.77d22e54.svg";